// @flow
import React, { Fragment } from 'react';

const MinimumFeeFootnote = () => (
  <Fragment>&dagger; There is a $20.00 minimum inspection fee</Fragment>
);

export default MinimumFeeFootnote;
